// extracted by mini-css-extract-plugin
module.exports = {"shareCard":"ShareCard_shareCard__3IOxd"};